import { useState } from 'react'
import { Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { apiRequest, invalidateCache } from '../../../shared/api/base'

const languages = [
  { id: 'sv', label: 'Svenska', flag: '\ud83c\uddf8\ud83c\uddea' },
  { id: 'en', label: 'English', flag: '\ud83c\uddec\ud83c\udde7' },
]

export default function LanguageExpanded() {
  const { i18n } = useTranslation()
  const currentLang = i18n.language
  const [saving, setSaving] = useState(false)

  const handleSelect = async (lang: string) => {
    if (lang === currentLang || saving) return

    const prev = currentLang
    i18n.changeLanguage(lang) // also updates localStorage via i18next cache
    setSaving(true)

    try {
      await apiRequest('/settings/preferences', {
        method: 'PATCH',
        body: JSON.stringify({ language: lang }),
      })
      invalidateCache('/settings/preferences')
    } catch {
      i18n.changeLanguage(prev)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="space-y-1">
      {languages.map(lang => (
        <button
          key={lang.id}
          onClick={(e) => {
            e.stopPropagation()
            handleSelect(lang.id)
          }}
          disabled={saving}
          className={`w-full flex items-center gap-3 p-2.5 rounded-lg transition-colors ${
            currentLang === lang.id
              ? 'bg-gold/10 border border-gold/30'
              : 'hover:bg-white/5 border border-transparent'
          } disabled:opacity-70`}
        >
          <span className="text-lg">{lang.flag}</span>
          <span className={`text-sm font-medium ${
            currentLang === lang.id ? 'text-ivory' : 'text-pearl/70'
          }`}>
            {lang.label}
          </span>
          {currentLang === lang.id && (
            <Check size={14} className="text-gold ml-auto" />
          )}
        </button>
      ))}
    </div>
  )
}
